/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ remaining: NonNullable<unknown>, limit: NonNullable<unknown> }} Directory_Submit_Quota_Remaining_MonthlyInputs */

const en_directory_submit_quota_remaining_monthly = /** @type {(inputs: Directory_Submit_Quota_Remaining_MonthlyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.remaining} of ${i?.limit} submissions left this month`)
};

const zh_directory_submit_quota_remaining_monthly = /** @type {(inputs: Directory_Submit_Quota_Remaining_MonthlyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`本月剩余 ${i?.remaining}/${i?.limit} 次提交`)
};

/**
* | output |
* | --- |
* | "{remaining} of {limit} submissions left this month" |
*
* @param {Directory_Submit_Quota_Remaining_MonthlyInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_submit_quota_remaining_monthly = /** @type {((inputs: Directory_Submit_Quota_Remaining_MonthlyInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Submit_Quota_Remaining_MonthlyInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_submit_quota_remaining_monthly(inputs)
	return zh_directory_submit_quota_remaining_monthly(inputs)
});
export { directory_submit_quota_remaining_monthly as "directory.submit.quota_remaining_monthly" }